import { computed } from "vue";

function walkDocNodes(node, cb) {
  if (!node || typeof node !== "object") return;
  if (node.type) cb(node);
  if (Array.isArray(node.content)) {
    node.content.forEach((child) => walkDocNodes(child, cb));
  }
}

/**
 * Считает незаполненные mention в документах TipTap.
 * «Незаполненный» = у ноды есть service_code, но value пустой.
 * Поля дедуплицируются по participant_type_code|key|service_code и считаются
 * один раз; поле идёт в счёт, если пустое хотя бы в одной языковой версии.
 * Пока считаем только service-mention; isNotary/isCustom не валидируем.
 *
 * @param {() => Array} getContents — вернуть массив doc-контентов (content, content_kz, content_en)
 */
export function useUnfilledMentions(getContents) {
  const unfilledMentionsCount = computed(() => {
    const byField = new Map();
    (getContents() || []).forEach((doc) => {
      walkDocNodes(doc, (node) => {
        if (node.type !== "mention") return;
        const attrs = node.attrs || {};
        if (!attrs.service_code) return;
        if (attrs.isNotary || attrs.isCustom) return;
        const id = `${attrs.participant_type_code || ""}|${attrs.key || ""}|${
          attrs.service_code
        }`;
        const value = attrs.value == null ? "" : String(attrs.value).trim();
        byField.set(id, byField.get(id) || value === "");
      });
    });
    let count = 0;
    byField.forEach((empty) => {
      if (empty) count += 1;
    });
    return count;
  });

  return { unfilledMentionsCount };
}
